import * as $ from "jquery";
import _ from 'underscore';
import tracking from '../../utils/tracking';
import downloadHelper from '../../common/download-helper';

export default class UpdateListView {
  loadTimes: number;
  domRoot: HTMLElement;
  $domRoot: JQuery<HTMLElement>;
  params: any;
  product: any;
  showEnterpriseColumn: any;
  showChecksum: any;
  
  showMostPopularDownloadFirst: any;
  mostPopularDownload: any;
  unsortedData: any[];
  data: any[];
  enterpriseData: any[];
  agreementData: any[];
  dropdown: any;
  dropdownEnterprise: any;
  dropdownAgreement: any;
  downloadLink: any;
  downloadChosen: any;
  url: any;
  secondURL: any;
  thirdURL: string;
  numOfCalls: number;
  sortedList: any[];
  enterpriseList: any[];
  indexedList: any;
  selectedProduct: { longVersion: string; downloads: any[]; };
  newestDownload: { longVersion: string; downloads: any[]; };
  latestEnterprise: { longVersion: string; downloads: any[]; };
  labels: any;
  baseTracking: { eventComponent: string; };

  constructor(domRoot: HTMLElement, params: any) {
    this.loadTimes = 0;
    this.domRoot = domRoot;
    this.$domRoot = $(domRoot);

    this.params = params;
    this.product = params.product;
    this.showEnterpriseColumn = params.showEnterprise ? params.showEnterprise : 'both';
    this.showChecksum = params.showChecksum;
    this.showMostPopularDownloadFirst = params.showMostPopularDownloadFirst;
    this.mostPopularDownload = params.mostPopularDownload;
    this.unsortedData = [];
    this.data = [];
    this.enterpriseData = [];
    this.agreementData = [];
    this.dropdown;
    this.dropdownEnterprise;
    this.dropdownAgreement;
    this.downloadLink;
    this.downloadChosen;
    this.url = params.productCurrentJSON;
    this.secondURL = params.productArchivedJSON;
    this.thirdURL = "https://api.atlassian.com/hams/1.0/public/downloads/binaryDownloads/jira/archived";
    this.numOfCalls = 0;
    this.sortedList = [];
    this.enterpriseList = [];
    this.indexedList;
    this.selectedProduct = {longVersion: "0.0.0", downloads: []};
    this.newestDownload = {longVersion: "0.0.0", downloads: []};
    this.latestEnterprise = {longVersion: "0.0.0", downloads: []};
    this.labels = params.labels;
    this.baseTracking = {
      eventComponent: "updateListView"
    };
    this.init()
  }
  init() {
    this.bindEvents();
    if ($('#second-page-area').length < 1) {
      $("#download-area").after('<div id="second-page-area"></div>');
      $("#download-area").after('<div id="enterprise-container" style="display: none;"></div>');
    }
    this.params.downloadInfo = this.groupBy(this.params.downloadInfo, 'os');

    this.getJSON(this.url);
    if (this.showEnterpriseColumn !== "standardOnly") {
      this.getJSON(this.secondURL);
    }
    if (this.product == "jira-combined") {
      this.getJSON(this.thirdURL);
    }
  }

  async getJSON(url: string) {
    const newData = await fetch(url,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        }
      })
      .then((res) => res.json())
      .catch();
    if (newData) {
      this.numOfCalls = this.numOfCalls + 1;
      var oldData = this.unsortedData;
      var joinedData = oldData.concat(newData);
      this.unsortedData = joinedData;
      this.addMetaData();
    }
  }

  showAgreementPage(isEnterprise, shouldShowDropdown) {
    window.scrollTo(0, 0);
    this.getTemplate("second-page", isEnterprise, shouldShowDropdown);
    $("#download-area, #second-page-area").addClass('drawer');
  }

  bindEvents() {
    var self = this;
    $('body')
      .on('click', '#eula-downloads-button', function() {
        if (!$(this).hasClass('disabled')) {
          $('#downloads-area, #second-page-area').hide();
          $('#post-download-area').show();
          var osIndex = $("#select-product-version")[0].selectedIndex;
          var selectedOSItem = $("#select-product-version")[0].children[osIndex];
          var selectedOS = selectedOSItem.getAttribute('data-product-platform');
          self.baseTracking.label = "Download Product Update";
          self.baseTracking.operatingSystem = selectedOS;
          tracking.trackEvent('Download Product Update', self.baseTracking);
        }
      })
      .on('click', '.expander', function(e) {
        self.baseTracking.productVersion = e.target.getAttribute('data-version');
        self.baseTracking.label = e.target.innerText.trim();
        if ($(this).next().is(':visible')) {
          $(this).text(self.labels.showDetails);
          $(this).next().slideUp();
          tracking.trackEvent('Hide downloads', self.baseTracking);
        } else {
          $(this).text(self.labels.hideDetails);
          $(this).next().slideDown();
          tracking.trackEvent('Show/expand downloads', self.baseTracking);
        }
      })
      .on('click', '#choose-another', function(e) {
        $("#download-area, #second-page-area").removeClass('drawer');
        self.baseTracking.label = e.target.innerText.trim(),
        tracking.trackEvent('Choose Another Product Download', self.baseTracking);
        window.scrollTo(0, 0);
      })
      .on('change', '#select-product-version', function() {
        var downloadURL = $(this).val();
        if ($('#download-eula-checkbox').is(':checked')) {
          $('#checksum-download a').attr('href', downloadURL + '.sha256');
          $('#checksum-download a').removeClass('disabled');

          $('#eula-downloads-button').attr('href', downloadURL);
          $('#download-installer-again a').attr('href', downloadURL);
        }
      })
      .on('change', '.choosing-product-version', function() {
        var downloadURL = $(this).val();
        self.downloadChosen = downloadURL;
        if ($('#download-eula-checkbox').is(':checked')) {
          $('#checksum-download a').attr('href', downloadURL + '.sha256');
          $('#checksum-download a').removeClass('disabled');

          $('#eula-downloads-button').attr('href', downloadURL);
          $('#download-installer-again a').attr('href', downloadURL);
        }
      })
      .on('change', '#download-eula-checkbox', function() {
        var downloadURL = $('#select-product-version').val()
        if ($(this).is(':checked')) {
          $('#download-installer-again a').attr('href', downloadURL);
          $('#checksum-download a').attr('href', downloadURL + '.sha256');
          $('#checksum-download a').removeClass('disabled');

          $('#eula-downloads-button').attr('href', downloadURL);
          $('#eula-downloads-button').removeClass('disabled');
        } else {
          $('#download-installer-again a').attr('href', '#');
          $('#checksum-download a').attr('href', '');
          $('#checksum-download a').addClass('disabled');

          $('#eula-downloads-button').attr('href', '')
          $('#eula-downloads-button').addClass('disabled');
        }
      })
      .on('click', '.release-notes', function(e) {
        self.baseTracking.label = e.target.innerText.trim(),
        self.baseTracking.productVersion = e.target.getAttribute('data-version');
        self.baseTracking.productEdition = e.target.getAttribute('data-edition').toLowerCase();
        tracking.trackEvent('Read release notes', self.baseTracking);
      })
      .on('click', '.product-versions', function(e) {
        var $this = $(this);
        var majorVersion = $this.attr('data-major-version');
        var minorVersion = $this.attr('data-minor-version');
        var version = $this.attr('data-version');
        self.selectedProduct = self.indexedList.find(item => majorVersion === item.majorVersion).minorVersion.find(item => minorVersion === item.minorVersion).versions.find(item => version === item.longVersion);
        self.baseTracking.productVersion = self.selectedProduct.longVersion;
        self.baseTracking.productEdition = self.selectedProduct.edition;
        self.baseTracking.label = e.target.innerText.trim();
        var shouldChangeDownloadsToEnterprise = self.showMostPopularDownloadFirst && self.selectedProduct.edition == "Enterprise";
        downloadHelper.retrieveData(self.selectedProduct.downloads, self.initialEvents, self, "update", shouldChangeDownloadsToEnterprise, "agreementData", $(this).hasClass('accordion'));
        self.showAgreementPage(shouldChangeDownloadsToEnterprise, $(this).hasClass('accordion'));
        tracking.trackEvent('Click to Agreement Page for product download', self.baseTracking);
        return false;
      })
      .on('click', "span.enterprise", function(e) {
        self.getTemplate("enterprise-modal");
        self.baseTracking.label = e.target.innerText.trim(),
        tracking.trackEvent('Learn more about enterprise - modal', self.baseTracking);
      })
      .on('click', ".close-enterprise-modal", function() {
        $('#enterprise-container').hide();
        self.baseTracking.label = 'Close modal',
        tracking.trackEvent('Close enterprise modal', self.baseTracking);
      });
  }

  htmlDecode(string){
    var e = document.createElement('textarea');
    e.innerHTML = string;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue.replace(/<\/p><br\/><br\/><p>/g, '</p><p>').replace(/(<br\/>)$/g, '');
  }

  // Load the underscore template in the .FTL
  getTemplate(name, isEnterprise, showDropdown) {
    var template;
    switch (name) {
      case "second-page":
        template = _.template($("#download-second-page").html());
        $('#second-page-area').html(template({
          labels: this.labels,
          mostPopularDownload: this.mostPopularDownload,
          isAccordion: showDropdown,
          showChecksum: this.showChecksum,
          showMostPopularDownloadFirst: this.showMostPopularDownloadFirst && !showDropdown,
          product: this.selectedProduct,
          downloads: this.agreementData,
          preChosenVersion: this.downloadChosen,
          os: downloadHelper.getOS(),
          productName: this.params.product.replace("JIRA", "Jira")
        }));
        break;
      case "download":
        var templateFill = isEnterprise && this.showEnterpriseColumn !== "enterpriseOnly" ? '#enterprise-standalone-block' : '#download-view';
        var thisProduct = isEnterprise ? this.latestEnterprise : this.newestDownload;
        var downloadData = isEnterprise ? this.enterpriseData : this.data;
        var helpText = this.htmlDecode(isEnterprise ? this.labels.helperTextEnterprise : this.labels.helperTextLatest);
        var comparisonVersionNumber = Number(thisProduct.longVersion.replace(/[^\d]/g, ''));
        template = _.template($("#download-template").html());
        if (comparisonVersionNumber > 0) {
          $(templateFill).html(template({
            labels: this.labels,
            productKey: this.product,
            product: thisProduct,
            downloads: downloadData,
            mostPopularDownload: this.mostPopularDownload,
            showMostPopularDownloadFirst: this.showMostPopularDownloadFirst,
            isEnterprise: isEnterprise,
            os: downloadHelper.getOS(),
            helperText: helpText,
            productName: this.params.product
          }));
        }
        break;
      case "accordion":
        template = _.template($("#accordion-template").html());
        $('#accordion-view').html(template({
          product: this.product,
          labels: this.labels,
          downloads: this.indexedList,
          activeVersion: this.newestDownload,
          latestEnterprise: this.latestEnterprise
        }));
        break;
      case "enterprise-modal":
        template = _.template($("#enterprise-modal-template").html());
        $('#enterprise-container').show().html(template({
          labels: this.labels,
          product: this.newestDownload
        }));
        break;
      default:
        return false;
    }
    // once template is loaded, grab the select element and to download button and store them
    this.dropdown = this.$domRoot.find('#select-product-standard-version');
    this.dropdownEnterprise = $('#select-product-enterprise-version');
    this.dropdownAgreement = $('#select-product-version');
    this.downloadLink = this.$domRoot.find('#downloads-button');
  }

  // .replace(/[^\d\.]/g, '') add metadata like file extension and major and minor version numbers for example "7" and "7.1" for version "7.1.8"
  addMetaData() {
    var versionSplit;
    var longVersion;
    var platform;
    var description;
    var self = this;
    if (this.unsortedData && this.unsortedData.length) {
      this.unsortedData.forEach(function(object) {
        platform = object.downloadLabels.map((label: any) => label.labelName).toString();
        longVersion = object.version.name;
        description = object.name;
        versionSplit = longVersion.split('.');
        var formattedDate = new Date(object.version.date);
        var day = ("0" + formattedDate.getDate()).slice(-2);
        var month = formattedDate.toLocaleString('default', { month: 'short' });
        var year = formattedDate.getFullYear();
        var zipURL = object.zipURL.replace("http:", "https:");
        if (self.product.indexOf('clover') > -1) {
          object.longVersion = longVersion.match(/(\d*)\.(\d*)\.(\d*)/) ? longVersion.name.match(/(\d*)\.(\d*)\.(\d*)/)[0] : longVersion.replace(/[^\d\.]/g, '');
          object.sortVersion = description.match(/Eclipse|Ant|IDEA/) ? description.match(/Eclipse|Ant|IDEA/)[0] : 'All';
        }
        try {
          object.majorVersion = versionSplit[0];
          object.minorVersion = versionSplit[0] + '.' + versionSplit[1].replace(/\-(.*?)$/, '');
          object.microVersion = versionSplit[2];
          object.longVersion = longVersion;
          object.platform = platform;
          object.date = `${day}-${month}-${year}`;
          object.description = description;
          object.downloadLink = zipURL;
          object.extension = downloadHelper.getFileExtension(zipURL);
        } catch (error) {
          object.majorVersion = longVersion;
          object.minorVersion = longVersion;
          object.microVersion = longVersion;
          object.longVersion = longVersion;
          object.platform = platform;
          object.date = `${day}-${month}-${year}`;
          object.description = description;
          object.downloadLink = zipURL;
          object.extension = downloadHelper.getFileExtension(zipURL);
        }
      });
      this.arrangeData();
    }
  }

  // Arrange each download version into a set where the downloads are stored as an array under sortedList.downloads
  arrangeData() {
    this.sortedList = [];
    var data = this.arrayFrom(this.groupBy(this.unsortedData, 'longVersion'));

    data.forEach((item) => {
      // get the first item to add some data to set (i.e. release date, release notes url, version numbers, etc)
      var firstItem = item[0] ? item[0] : {};
      var newObject = {
        "product": this.params.productName,
        "description": firstItem.description,
        "version": firstItem.version,
        "edition": firstItem.edition,
        "date": firstItem.date,
        "extension": firstItem.extension,
        "longVersion": firstItem.longVersion,
        "sortVersion": firstItem.sortVersion,
        "majorVersion": firstItem.majorVersion,
        "minorVersion": firstItem.minorVersion,
        "microVersion": firstItem.microVersion,
        "released": firstItem.released,
        "releaseNotes": firstItem.releaseNotes,
        "downloadLink": firstItem.downloadLink,
        "downloads": item
      };
      var biggerOfCurrentAndEnterprise = this.versionComparer(newObject, this.latestEnterprise);
      this.latestEnterprise = biggerOfCurrentAndEnterprise && biggerOfCurrentAndEnterprise.edition === "Enterprise" ? biggerOfCurrentAndEnterprise : this.latestEnterprise;

      var biggerOfCurrentAndNewest = this.versionComparer(newObject, this.newestDownload);
      this.selectedProduct = this.newestDownload = biggerOfCurrentAndNewest;

      this.sortedList.push(newObject);
    });
    this.indexList();

    this.baseTracking.productKey = this.selectedProduct.product;
    downloadHelper.retrieveData(this.newestDownload.downloads, this.initialEvents, this, "update", false, "data");
    downloadHelper.retrieveData(this.latestEnterprise.downloads, this.initialEvents, this, "update", true, "enterpriseData");
  }

  indexList() {
    let arrangedList = this.sortedList.reduce((acc, download) => {
      let majorVersionIndex = acc.findIndex(item => item.majorVersion === download.majorVersion);
      if (majorVersionIndex < 0) {
        let majorVersionObj = {
          majorVersion: download.majorVersion,
          minorVersion: []
        };
        acc.push(majorVersionObj);
        majorVersionIndex = acc.indexOf(majorVersionObj);
      }

      let minorVersionIndex = acc[majorVersionIndex].minorVersion.findIndex(item => item.minorVersion === download.minorVersion);
      if (minorVersionIndex < 0) {
        let minorVersionObj = {
          minorVersion: download.minorVersion,
          versions: []
        };
        acc[majorVersionIndex].minorVersion.push(minorVersionObj);
        minorVersionIndex = acc[majorVersionIndex].minorVersion.indexOf(minorVersionObj);
      }

      acc[majorVersionIndex].minorVersion[minorVersionIndex].versions.push(download);
      return acc;
    }, []);

    let sortedMajorVersion = arrangedList.sort((a, b) => b.majorVersion - a.majorVersion);
    sortedMajorVersion.forEach((majorVersionObj, index) => {
      sortedMajorVersion[index].minorVersion = majorVersionObj.minorVersion.sort((a, b) => {
        let a_minor = this.versionSplitter(a.minorVersion, 1);
        let b_minor = this.versionSplitter(b.minorVersion, 1);
        return b_minor - a_minor;
      });
      sortedMajorVersion[index].minorVersion.forEach((minorVersionObj, minorIndex) => {
        sortedMajorVersion[index].minorVersion[minorIndex].versions = minorVersionObj.versions.sort((a, b) => {
          let a_version = a.microVersion;
          let b_version = b.microVersion;
          return b_version - a_version;
        });
      });
    });
    this.indexedList = sortedMajorVersion;
  }

  hasOnlyNumbers(version) {
    return /^\d+$/.test(version);
  }

  versionSplitter(string, position) {
    if (string && string.split('.')[position]) {
      var matcher = string.split('.')[position].match(/^[0-9]+/);
      if (matcher && matcher[0]) {
        return Number(string.split('.')[position].match(/^[0-9]+/)[0]);
      }
      return 0;
    }
    return 0;
  }

  versionParser(item) {
    var numArray = [];
    var itemVersion = item && item.longVersion && item.longVersion.length ? item.longVersion : '0.0.0';
    itemVersion.split('.').forEach((dig) => {
      var digit = isNaN(Number(dig)) ? dig : Number(dig);
      numArray.push(digit);
    });
    return numArray;
  }

  versionComparer(a, b) {
    let a_version = this.versionParser(a);
    let b_version = this.versionParser(b); // currentNewestx

    for (var i = 0; i < b_version.length; i++) {
      if (b_version[i] !== a_version[i] || (i + 1 == b_version.length)) {
        var bigger = a_version.every(vers => ((this.hasOnlyNumbers(vers)) || this.url.includes("/eap/")) && a_version[i] > b_version[i]) ? a : b;
        // keeps EAP version from showing as main download only if it's the standard non-EAP downloads feed

        return bigger;
      } else {
        continue;
      }
    }
  }

  // this is called in the arrangData() as the callback in the retrieveData(data, callback, context). Context is "this"
  initialEvents(context) {
    context.getTemplate('download');
    context.getTemplate('download', true);
    context.getTemplate("accordion");
    downloadHelper.changeDownload(context.dropdownEnterprise, context.downloadLink);
    downloadHelper.changeDownload(context.dropdownAgreement, context.downloadLink);
    downloadHelper.changeDownload(context.dropdown, context.downloadLink);
    downloadHelper.download(context.$domRoot, context.downloadLink);
  }

  arrayFrom(object) {
    let returnedArray = [];
    for (let key in object) {
      returnedArray.push(object[key]);
    }
    return returnedArray;
  }

  groupBy(xs, key) {
    if (xs.reduce) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    }
    return xs;
  }

  camelCaser(text) {
    var camelString = text.toLowerCase().split(' ');
    for (var c = 0; c < camelString.length; c++) {
      if (c > 0) {
        camelString[c] = camelString[c].charAt(0).toUpperCase() + camelString[c].slice(1);
      }
    }
    return camelString.join('');
  }

}
